import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { addAdmin } from "../Apis/SuperadminApis";
import { useNavigate } from "react-router-dom";
import PopupMessage from "../PopupMessage/PopupMessage";
import "./AddAdmin.css";

const AddAdmin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value.trimStart()
  }));
};

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  if (isLoading) return;
  if (!formData.email.trim()) {
    setPopupMessage("Email is required");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (!validateEmail(formData.email)) {
    setPopupMessage("Please enter a valid email address");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  try {
    setIsLoading(true);

    const response = await addAdmin({
      email: formData.email.trim()
    });
if (response?.error) {

  // Session expired handling
  if (response.error.includes("Unauthorized")) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    return;
  }

  // Other API errors
  setPopupMessage(response.error);
  setPopupType("error");
  setPopupOpen(true);

  return;
}else if (response.message) {
      setPopupMessage(response.message);
      setPopupType("success");
      setPopupOpen(true);
      setFormData({ email: "" });
    }
} catch (err) {

  if (
    err?.response?.status === 401 ||
    err?.response?.data?.error?.includes("Unauthorized")
  ) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    return;
  }

  const errorMsg =
    err?.response?.data?.error ||
    "Failed to add admin. Please try again.";

  setPopupMessage(errorMsg);
  setPopupType("error");
  setPopupOpen(true);

  console.error("Error adding admin:", err);
} finally {
    setIsLoading(false);
  }
};
  return (
  <div className="dashboard-wrapper">
  <Sidebar />

  <PopupMessage
    isOpen={popupOpen}
    onClose={() => setPopupOpen(false)}
    message={popupMessage}
    type={popupType}
  />

  <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Add New Admin</h1>
            <p className="dashboard-subtitle">Invite administrators to manage the platform</p>
          </div>
          </div>

        <div className="add-admin-form-container">
          <div className="add-admin-form-card">
            <div className="add-admin-form-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
              </svg>
            </div>
            
            <h2 className="add-admin-form-title">Admin Invitation</h2>
            <p className="add-admin-form-description">
              Send an invitation email to add a new administrator. 
              The recipient will receive a link to complete their registration.
            </p>
            
            <form onSubmit={handleSubmit} className="add-admin-form">
              <div className="add-admin-form-group">
                <label htmlFor="email" className="add-admin-label">
                  Email Address
                </label>
                <div className="add-admin-input-wrapper">
                  <svg className="add-admin-input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                  </svg>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="admin@example.com"
                    className="add-admin-input"
                    disabled={isLoading}
                  />
                </div>
                <div className="add-admin-input-hint">
                  The admin will receive an invitation email at this address
                </div>
              </div>
              
              <button
                type="submit"
                className="add-admin-submit-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg className="add-admin-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeDasharray="31.4 31.4" fill="none"/>
                    </svg>
                    Sending Invitation...
                  </>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Send Invitation
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAdmin;